


















/* Created- 22 - Mar - 2019 */
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import ActionListV2 from "@/Ui-Components/Common/List/ActionListV2.vue";
import ParticaCard from "@/Ui-Components/Common/Container/ParticaCard.vue";
import ParticaView from "@/Ui-Components/Common/ParticaView.vue";
import { ListItemDTO } from "../../Generated/ParticaAPI";
import { ButtonConfig } from "../../Models/Buttons";
import { eParticaAction, ParticaEvent, getActionName } from "../../Models/ParticaEvent";
import ParticaStreamSubBase from "../Base/ParticaStreamSubBase.vue";
import { INavigationService } from "../../NavigationServices/navigation";
import ParticaArticlePreview from "@/Ui-Components/Article/Preview/ParticaArticlePreview.vue";
import { IArticle, Article } from "../../Models/ArticleModels/article";
import { IParticaStoreService } from "../../BusinessServices/particastore";

@Component(
	{
		name: "ContentSubscriptions",
		components: { ActionListV2, ParticaCard, ParticaView, ParticaArticlePreview }
	})
export default class ContentSubscriptions extends ParticaStreamSubBase {
	@Prop() private id: number;

	private store: IParticaStoreService;
	private svc: INavigationService;
	private listdata = [] as ListItemDTO[];
	private showpreviewarticle: boolean = false;
	private previewarticle: IArticle = new Article() as IArticle;

	private listactions: ButtonConfig[] = [ // init our menu for the list.
		{ action: eParticaAction.ARTICLE_PREVIEW, label: "View" } as ButtonConfig,
	];

	private async eventHandler(event: ParticaEvent) {
		try {
			this.LoadingStart();
			switch (event.action) {
				case eParticaAction.ARTICLE_PREVIEW: {
					this.previewarticle = await this.store.getStreamArticle(event.item.id);
					this.showpreviewarticle = true;
					break;
				}
				default: {
					this.baseEventHandler(event);
				}

			}
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured loading the content stream ${this.id}`
			);
		} finally {
			this.LoadingEnd();
		}
	}



	@Watch("$route")
	private async change(to: any, from: any) {
		await this.init();
	}
	private async mounted() {
		this.metadata.name = "Subscription Articles";
		await this.init();
	}

	private async init() {
		try {
			this.LoadingStart();
			this.svc = this.particaServices.getNavigationService();
			this.store = this.particaServices.getParticaStoreService();
			await this.getStreamSubNav(this.id);
			this.listdata = await this.svc.getArticlesForStreamSubscription(this.id);
		} catch (e) {
			this.ShowErrorDialog(
				e,
				`An error occured loading the content stream ${this.id}`
			);
		} finally {
			this.LoadingEnd();
		}
	}
}
